// extracted by mini-css-extract-plugin
export default {"cardImg":"Trainers_cardImg__ihqS7","cardDescription":"Trainers_cardDescription__e8om3","card":"Trainers_card__4cwRu"};